import axios from '@axios'

const route = 'system/whats'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    connect(context) {
      return axios.get(`${route}/connect`)
    },
    disconnect(context) {
      return axios.get(`${route}/disconnect`)
    },
    reconnect(context) {
      return axios.get(`${route}/reconnect`)
    },
    getStatus(context) {
      return axios.get(`${route}/status`)
    },
  },
}
